import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const SEOPageRBAC = {
  pageID: '2a023d1e574ff78c11db5814e43d9c05',
  elementID: {
    View: 'ba5b1c3d9ada387a2bbe42f887a776d6',
    Save: 'ba5b295964da387a2bbe42f88cecda86',
    Publish: 'c18240655a8f383d1cfd981106658a1a',
  },
} as const

export const useRBACSEOPage = createUseRBAC(SEOPageRBAC.elementID)

export type UseRBACSEOPageType = ReturnType<typeof useRBACSEOPage>
